<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1">
              <span slot="tab">
                <a-icon type="medicine-box"/>
                Incapacidades presentadas
              </span>
          <a-card>
            <g-master name="forms"
                      :endpoint="master.endpoint"
                      :tableSetup="master.tableSetup"
                      :modalFieldsSetup="master.modalFieldsSetup"
                      :parentData="parentData"
                      :beforeSend="master.beforeSend"
                      :actions="false"
                      ref="master"
            >
              <template slot="masterModal" slot-scope="{record}">
                <a-row :gutter="[16,16]">
                </a-row>
              </template>
            </g-master>
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab">
                <a-icon type="container"/>
                Recomendaciones médicas
              </span>
          <recomendaciones-medicas v-if="empleadoseleccionado"
                                   :empleadoseleccionado="empleadoseleccionado"></recomendaciones-medicas>
        </a-tab-pane>
        <a-tab-pane key="3">
          <span slot="tab">
                <a-icon type="file-exclamation"/>
                Ayudas ergonómicas
              </span>
          <ayudas-ergonomicas v-if="empleadoseleccionado"
                              :empleadoseleccionado="empleadoseleccionado"></ayudas-ergonomicas>
        </a-tab-pane>
        <a-tab-pane key="4">
          <span slot="tab">
                <a-icon type="warning"/>
                Casos reportados
              </span>
          <casos-reportados v-if="empleadoseleccionado" :empleadoseleccionado="empleadoseleccionado"></casos-reportados>
        </a-tab-pane>
        <a-tab-pane key="5">
          <span slot="tab">
                <a-icon type="audit"/>
                Accidentes de trabajo
              </span>
          <accidentes-trabajo v-if="empleadoseleccionado"
                              :empleadoseleccionado="empleadoseleccionado"></accidentes-trabajo>
        </a-tab-pane>
        <a-tab-pane key="6">
          <span slot="tab">
                <a-icon type="woman"/>
                Embarazo actual
              </span>
          <embarazo-actual v-if="empleadoseleccionado" :empleadoseleccionado="empleadoseleccionado"></embarazo-actual>
        </a-tab-pane>
        <a-tab-pane key="7">
          <span slot="tab">
                <a-icon type="safety"/>
                Voluntariado SST
              </span>
          <voluntariado-sst v-if="empleadoseleccionado" :empleadoseleccionado="empleadoseleccionado"></voluntariado-sst>
        </a-tab-pane>
        <a-tab-pane key="8">
          <span slot="tab">
               <a-icon type="shop"/>
                Lugar de trabajo
              </span>
          <lugar-de-trabajo v-if="empleadoseleccionado" :empleadoseleccionado="empleadoseleccionado"></lugar-de-trabajo>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'absen',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'abs_id'
            },
            columns: [
              {title: 'ID Ausentismo', dataIndex: 'abs_id', sorter: true},
              {title: 'Tipo de ausentismo', dataIndex: 'tipo_abs', sorter: true},
              {title: 'Días de ausentismo', dataIndex: 'abs_days', sorter: true},
              {title: 'Inicio del ausentismo', dataIndex: 'abs_inicial', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/IncapacidadesPresentadas.vue